const images = {
    logo: require('~/assets/images/simpill_logo.png'),
    folder: require('~/assets/images/folder.png'),
    symptom: require('~/assets/images/symptom.png'),
    supplement: require('~/assets/images/supplement.png'),
};

export default images;
